import axios from 'axios'
import { DashBoard } from '@/domain/DashBoard'

/**
 * ダッシュボードサービス
 */
export default class DashBoardService {
    /** インスタンス */
    private static _instance: DashBoardService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new DashBoardService();
        }
        return this._instance;
    }

    /**
     * ダッシュボード情報を取得
     */
    public async info(): Promise<DashBoard> {
        return await axios.get("/api/dash_board")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as DashBoard)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }
}
